module.exports = __webpack_public_path__ + "img/04.534ef9c5.jpg";